import { createFileRoute } from '@tanstack/react-router';

import { SubscriptionPage } from '../modules/subscription/ui/pages/SubscriptionPage';

export const Route = createFileRoute('/_authenticated/dashboard/settings/subscription/')({
  component: SubscriptionPage,
  staticData: {
    breadcrumb: ['Manage', 'Settings', 'Subscription'],
  },
});
